module.exports = __webpack_public_path__ + "static/media/tt_commons_var_roman-webfont.31b1191d.woff";